import {
  Check,
  CircleX,
  Lightbulb,
  type LucideIcon,
  Mail,
  Phone,
  RotateCcw,
  Send,
  SmilePlus,
} from "lucide-react";
import type { AutoMessageType } from "../../types/messages.ts";
import { Forward, Reply } from "../icons/customIcons.tsx";

/**
 * The glyph shown next to each auto message's line. Web-only — the copy that
 * pairs with it is shared with native in `@/shared/autoActionText.ts`.
 */
export const autoActionIcon: Record<AutoMessageType, LucideIcon> = {
  autoLearnMore: Lightbulb,
  autoReply: Reply,
  autoReplyAll: Reply,
  autoForward: Forward,
  autoMemoryConfirmed: Check,
  autoSendEmailDraft: Send,
  autoCancelEmailDraft: CircleX,
  autoSendInvitation: Send,
  autoCancelInvitation: CircleX,
  autoAcceptRsvp: Check,
  autoDeclineRsvp: CircleX,
  autoTentativeRsvp: CircleX,
  autoApplyEventChange: Check,
  autoCancelEventChange: CircleX,
  autoApplyContactChange: Check,
  autoCancelContactChange: CircleX,
  autoMakePhoneCall: Phone,
  autoCancelPhoneCall: CircleX,
  autoAskUserFormSubmit: Check,
  autoExecuteBrief: Check,
  autoCancelBrief: CircleX,
  autoApproveScheduling: Check,
  autoCounterProposeScheduling: CircleX,
  autoCancelScheduling: CircleX,
  autoApproveSchedulingKickoff: Check,
  autoCancelSchedulingKickoff: CircleX,
  autoApproveRoutine: Check,
  autoCancelRoutine: CircleX,
  autoApproveDocument: Check,
  autoApproveSkill: Check,
  autoCancelSkill: CircleX,
  autoApproveApplet: Check,
  autoTaskCompleted: Check,
  autoTaskCancelled: CircleX,
  autoTaskReopened: RotateCcw,
  autoSendExternalMessage: Check,
  autoCancelExternalMessage: CircleX,
  autoOAuthConnected: Check,
  autoConnectorPickerDone: Check,
  autoPickerDone: Check,
  autoOAuthCancelled: CircleX,
  autoCommunicationReceived: Mail,
  autoReaction: SmilePlus,
};
